var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.hasImage
      ? _c("img", {
          staticClass: "media-image",
          class: { "media-image-show-on-desktop": !_vm.hasVideo },
          attrs: { src: _vm.imageSrc }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.hasVideo
      ? _c(
          "video",
          {
            staticClass: "media-video",
            attrs: {
              preload: "auto",
              autoplay: "",
              muted: "",
              loop: "",
              playsinline: "",
              poster: _vm.videoPoster
            },
            domProps: { muted: true }
          },
          [_c("source", { attrs: { src: _vm.videoSrc, type: "video/mp4" } })]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }